import React from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import useAuth from "../../Hooks/useAuth";

const ProductTab = () => {
  const {showDummyImage} = useAuth()
  return (
    <div className="product-tab">
      <Tabs>
        <TabList className="product-tabs-btn">
          <Tab className="product-tab-btn">Details</Tab>
          <Tab className="product-tab-btn">Bids</Tab>
          <Tab className="product-tab-btn">History</Tab>
        </TabList>
        <TabPanel>
          <div className="product-details">
            <div className="product-details-item">
              <p>Background</p>
              <h4>Cool Gray</h4>
              <small>4.8 % rarity</small>
            </div>
            <div className="product-details-item">
              <p>Background</p>
              <h4>Cool Gray</h4>
              <small>4.8 % rarity</small>
            </div>
            <div className="product-details-item">
              <p>Background</p>
              <h4>Cool Gray</h4>
              <small>4.8 % rarity</small>
            </div>
            <div className="product-details-item">
              <p>Clothing</p>
              <h4>Turquoise Kimono</h4>
              <small>4.8 % rarity</small>
            </div>
            <div className="product-details-item">
              <p>Clothing</p>
              <h4>Turquoise Kimono</h4>
              <small>4.8 % rarity</small>
            </div>
            <div className="product-details-item">
              <p>Clothing</p>
              <h4>Turquoise Kimono</h4>
              <small>4.8 % rarity</small>
            </div>
            <div className="product-details-item">
              <p>Clothing</p>
              <h4>Turquoise Kimono</h4>
              <small>4.8 % rarity</small>
            </div>
          </div>
        </TabPanel>
        <TabPanel>
          <div className="bids">
            <div className="bids-item">
              <div className="bids-item-left">
                <img src={require("../../assets/images/common/owner.png")} alt={'owner'} onError={({currentTarget},imageSize='45X45')=>showDummyImage({currentTarget},imageSize)}/>
              </div>
              <div className="bids-item-right">
                <h5>
                  7.77 wETH <span>by</span> PAULchong424
                </h5>
                <p>
                  6/20/2022, 8:18 PM <small>Floor bid</small>
                </p>
              </div>
            </div>
            <div className="bids-item">
              <div className="bids-item-left">
                <img src={require("../../assets/images/common/owner.png")} alt={'owner'}  onError={({currentTarget},imageSize='45X45')=>showDummyImage({currentTarget},imageSize)}/>
              </div>
              <div className="bids-item-right">
                <h5>
                  7.77 wETH <span>by</span> PAULchong424
                </h5>
                <p>
                  6/20/2022, 8:18 PM <small>Floor bid</small>
                </p>
              </div>
            </div>
            <div className="bids-item">
              <div className="bids-item-left">
                <img src={require("../../assets/images/common/owner.png")} alt={'owner'}  onError={({currentTarget},imageSize='45X45')=>showDummyImage({currentTarget},imageSize)}/>
              </div>
              <div className="bids-item-right">
                <h5>
                  7.77 wETH <span>by</span> PAULchong424
                </h5>
                <p>
                  6/20/2022, 8:18 PM <small>Floor bid</small>
                </p>
              </div>
            </div>
            <div className="bids-item">
              <div className="bids-item-left">
                <img src={require("../../assets/images/common/owner.png")} alt={'owner'}  onError={({currentTarget},imageSize='45X45')=>showDummyImage({currentTarget},imageSize)}/>
              </div>
              <div className="bids-item-right">
                <h5>
                  7.77 wETH <span>by</span> PAULchong424
                </h5>
                <p>
                  6/20/2022, 8:18 PM <small>Floor bid</small>
                </p>
              </div>
            </div>
            <div className="bids-item">
              <div className="bids-item-left">
                <img src={require("../../assets/images/common/owner.png")} alt={'owner'}  onError={({currentTarget},imageSize='45X45')=>showDummyImage({currentTarget},imageSize)}/>
              </div>
              <div className="bids-item-right">
                <h5>
                  7.77 wETH <span>by</span> PAULchong424
                </h5>
                <p>
                  6/20/2022, 8:18 PM <small>Floor bid</small>
                </p>
              </div>
            </div>
          </div>
        </TabPanel>
        <TabPanel>
          <div className="history">
            <div className="history-item">
              <div className="history-item-left">
                <img src={require("../../assets/images/common/owner.png")} alt={'owner'}  onError={({currentTarget},imageSize='45X45')=>showDummyImage({currentTarget},imageSize)}/>
              </div>
              <div className="history-item-right">
                <h5>
                  <span>Listed for</span> 14.98 ETH
                </h5>
                <p>
                  by<span>0xeb5...2e93 </span> 5/29/2022, 10:45 PM
                </p>
              </div>
            </div>
            <div className="history-item">
              <div className="history-item-left">
                <img src={require("../../assets/images/common/owner.png")} alt={'owner'}  onError={({currentTarget},imageSize='45X45')=>showDummyImage({currentTarget},imageSize)}/>
              </div>
              <div className="history-item-right">
                <h5>
                  <span>Listed for</span> 14.98 ETH
                </h5>
                <p>
                  by<span>0xeb5...2e93 </span> 5/29/2022, 10:45 PM
                </p>
              </div>
            </div>
            <div className="history-item">
              <div className="history-item-left">
                <img src={require("../../assets/images/common/owner.png")} alt={'owner'}  onError={({currentTarget},imageSize='45X45')=>showDummyImage({currentTarget},imageSize)}/>
              </div>
              <div className="history-item-right">
                <h5>
                  <span>Listed for</span> 14.98 ETH
                </h5>
                <p>
                  by<span>0xeb5...2e93 </span> 5/29/2022, 10:45 PM
                </p>
              </div>
            </div>
            <div className="history-item">
              <div className="history-item-left">
                <img src={require("../../assets/images/common/owner.png")} alt={'owner'}  onError={({currentTarget},imageSize='45X45')=>showDummyImage({currentTarget},imageSize)}/>
              </div>
              <div className="history-item-right">
                <h5>
                  <span>Listed for</span> 14.98 ETH
                </h5>
                <p>
                  by<span>0xeb5...2e93 </span> 5/29/2022, 10:45 PM
                </p>
              </div>
            </div>
            <div className="history-item">
              <div className="history-item-left">
                <img src={require("../../assets/images/common/owner.png")} alt={'owner'}  onError={({currentTarget},imageSize='45X45')=>showDummyImage({currentTarget},imageSize)}/>
              </div>
              <div className="history-item-right">
                <h5>
                  <span>Listed for</span> 14.98 ETH
                </h5>
                <p>
                  by<span>0xeb5...2e93 </span> 5/29/2022, 10:45 PM
                </p>
              </div>
            </div>
          </div>
        </TabPanel>
      </Tabs>
    </div>
  );
};

export default ProductTab;
